<template>
  <div>
    <div class="animated fadeIn container-fluid">
      <h3>期作查詢</h3>

      <b-card>
        <b-row>
          <b-col md="6">
            <b-input-group class="mb-3">
              <b-input-group-prepend>
                <b-input-group-text>輸入關鍵字</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="text"
                class="form-control"
                v-model.trim="search_keyword"
                :maxlength="50"
                size="lg"
              />
            </b-input-group>
            <div class="text-muted">
              <i class="fa fa-info-circle"></i>
              關鍵字搜尋欄位為：期作名稱、期作描述、期作田區、期作備註
            </div>
            <br />
          </b-col>
          <b-col md="12">
            <h4>篩選項目</h4>

            <div>
              <b-row class="filter-item-list">
                <b-col
                  md="6"
                  class="filter-item"
                  v-for="(data_agent, key_agent, idx_agent) in agent_switches"
                  :key="idx_agent"
                >
                  <div class="filter-item-icon">
                    <i class="fa fa-square"></i>
                  </div>
                  <div class="filter-item-name">{{ data_agent.name }}</div>
                  <b-form-group class="filter-item-options">
                    <b-form-radio-group
                      v-model="data_agent.value"
                      :options="options_agent_switches"
                    ></b-form-radio-group>
                  </b-form-group>

                  <div
                    class="filter-item-search-mark"
                    v-if="data_agent.value != undefined"
                  >
                    <i class="fa fa-filter"></i> Filter
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <div class="text-center">
          <b-button variant="success" size="lg" @click="redo_search">
            <i class="fa fa-search"></i>
            {{ $t("menu.search") }}
          </b-button>
        </div>
      </b-card>

      <!-- 阿龜資料讀取畫面 -->
      <div v-if="loading">
        <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
      </div>

      <!-- 顯示：表格 -->
      <div v-else>
        <b-card>
          <b-row>
            <b-col md="4">
              <b-form-group label-cols-sm="5" label="每頁顯示數量" class="mb-0">
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <div v-if="search_result.length > 0">
            <div class="list-table-result scroll-style-gray overflow-x">
              <b-table
                hover
                small
                responsive="xl"
                :fields="table_fields"
                :items="table_items"
              >
                <!-- A virtual column -->
                <template #cell(id)="row">
                  <div class="cp-info-id">{{ row.item.id }}</div>
                </template>

                <template #cell(name)="row">
                  <div
                    class="cp-info-name clickable"
                    @click="
                      go_ToPage({
                        name: 'Edit Cropperiod',
                        params: {
                          projectID: row.item.project_id,
                          cropperiodID: row.item.id,
                        },
                      })
                    "
                  >
                    {{ row.item.name }}
                  </div>
                </template>

                <template #cell(status)="row">
                  <b-badge
                    :variant="
                      $tools.style.variantStatusButton(
                        'cropperiod',
                        row.item.status,
                        false
                      )
                    "
                    >{{ $t("status.cropperiod." + row.item.status) }}</b-badge
                  >
                </template>

                <template #cell(description)="row">
                  <div class="cp-info-description">
                    {{ $tools.ui.shortenText(row.item.description, 50) }}
                  </div>
                </template>

                <template #cell(start_date)="row">
                  <div class="cp-info-date">
                    {{ row.item.start_date }}
                  </div>
                </template>
                <template #cell(end_date)="row">
                  <div class="cp-info-date">
                    {{ row.item.end_date }}
                  </div>
                </template>

                <template #cell(note)="row">
                  <div class="cp-info-note" v-if="row.item.note">
                    {{ row.item.note }}
                  </div>
                </template>
              </b-table>
            </div>
          </div>
          <div v-else>
            <NoData></NoData>
          </div>

          <!-- 分頁 -->
          <b-row v-if="perPage" class="justify-content-center">
            <b-col md="12" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="data_count"
                :per-page="perPage"
                aria-controls="search-list"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/views/components/NoData";
import AgriLoading from "@/views/components/AgriLoading";

export default {
  components: {
    NoData,
    AgriLoading,
  },
  data() {
    return {
      loading: false,
      search_keyword: "",
      agent_switches: {},
      options_agent_switches: [
        { text: "不篩選", value: null },
        { text: "不計算", value: false },
        { text: "計算", value: true },
      ],
      search_result: [],
      data_count: 0,

      // table
      table_fields: [
        // { key: 'idx',  sortable: true },
        { key: "id", sortable: true, label: "期作ID" },
        { key: "name", sortable: true },
        { key: "status", sortable: true },
        { key: "description", sortable: true },
        // { key: 'project_id', sortable: true },
        // { key: 'project_service_level', sortable: true },
        { key: "farm_field", sortable: true, label: "田區" },
        { key: "start_date", sortable: true, label: "開始日期" },
        { key: "end_date", sortable: true, label: "結束日期" },
        { key: "note", sortable: true },
      ],
      table_items: [],
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
        // { value: undefined, text: 'all' },
      ],
    };
  },
  mounted() {
    this.agent_switches = this.$tools.data.deepCopy_object(
      this.list_agent_switches.cropperiod
    );
  },
  computed: {
    ...mapState({
      list_agent_switches: (state) => state.admin.agent_switches,
    }),

    api_queryItem() {
      let _query = {};

      // 過濾托姆開關
      for (let _agent in this.agent_switches) {
        if (this.agent_switches[_agent].value != undefined)
          _query[_agent] = this.agent_switches[_agent].value;
      }

      // 查詢關鍵次
      if (this.search_keyword != undefined && this.search_keyword.length > 0) {
        _query.q = this.search_keyword;
      }

      // 分頁查詢
      if (this.perPage != undefined && this.currentPage > 0) {
        _query.limit = this.perPage;
        _query.skip = (this.currentPage - 1) * this.perPage;
      }

      return _query;
    },
  },
  watch: {
    perPage() {
      this.search_Cropperiods();
    },
    currentPage() {
      this.search_Cropperiods();
    },
  },
  methods: {
    go_ToPage(page) {
      this.$router.push(page);
    },

    // 按搜尋按鈕要將當下頁數調回第一頁
    redo_search() {
      this.currentPage = 1;
      this.search_Cropperiods();
    },

    search_Cropperiods() {
      this.loading = true;

      this.$store
        .dispatch("cropperiod/searchCropperiods", this.api_queryItem)
        .then((res) => {
          this.loading = false;
          if (res) {
            this.data_count = res.total_count;
            this.search_result = res.cropperiods;
            this.arrangeTableData();
          }
          // console.log( this.search_result )
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    arrangeTableData() {
      let _items = [];
      this.search_result.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items;
    },
  },
};
</script>

<style lang="scss">
.filter-item-options {
  .custom-control.custom-control-inline.custom-radio .custom-control-input,
  .custom-control.custom-control-inline.custom-radio .custom-control-label {
    cursor: pointer !important;
  }
}
</style>

<style lang="scss" scoped>
// .filter-item-list
// {
// }
// .filter-item
// {
// }
.filter-item-icon {
  display: inline-block;
  color: #73a70a;
}
.filter-item-name {
  display: inline-block;
  margin-right: 10px;

  // padding-left: 5px;
  // border-left: 3px solid #73a70a;
}
.filter-item-options {
  display: inline-block;
}
.filter-item-search-mark {
  display: inline-block;
  color: #e25353;
  i {
    font-size: 1.5rem;
    line-height: 1rem;
    margin: 0px;
  }
}

.cp-info-name {
  min-width: 150px;
}
.cp-info-id {
  display: inline-block;
  font-size: 1rem;
  text-align: center;
  width: 30px;
  padding: 2px 5px;
  margin-right: 5px;
  color: #73a70a;
  // background-color: #d2f095;
  // border-radius: 3px;
}
.cp-info-description {
  display: inline-block;
  font-size: 0.95rem;
}
.cp-info-date {
  margin: 5px;
  color: #636262;
  font-size: 0.9rem;
}
.cp-info-note {
  margin: 2px;
  padding: 3px 8px;
  color: #636262;
  background-color: #ececec;
  font-size: 0.85rem;
  border-radius: 3px;
}
</style>
